export const API = (
  import.meta.env.VITE_API_URL
).replace(/\/+$/, "");

console.log("OjMee Orbit API URL:", API);

export async function api(
  path,
  options = {},
) {
  const token =
    localStorage.getItem("token") || "";

  const response = await fetch(
    `${API}${path}`,
    {
      ...options,

      headers: {
        "Content-Type": "application/json",

        ...(token
          ? {
              Authorization: `Bearer ${token}`,
            }
          : {}),

        ...options.headers,
      },
    },
  );

  let data = {};

  try {
    data = await response.json();
  } catch {

  }

  if (!response.ok) {
    throw new Error(
      data.message ||
        `Request failed with status ${response.status}`,
    );
  }

  return data;
}